<template>
  <page-outline :title="$t('profilesPage.profiles_title')"
    iconFA="fa fa-address-card">

    <template slot="pageContent">
      <b-row class="justify-content-start">
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.idtfr')" :inputValue="accountLogin">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.eml')" :inputValue="accountEmailReference">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.nme')" :inputValue="accountName">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.adrs')" :inputValue="accountAddress">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.cty')" :inputValue="accountCity">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.zp_code')" :inputValue="accountZipCode">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.ctry')" :inputValue="accountCountry">
          </form-read-group-label-input>
        </b-col>
        <b-col v-if="accountType === '1'" sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.lgl_frm')" :inputValue="accountLegalForm">
          </form-read-group-label-input>
        </b-col>
        <b-col v-if="accountType === '1'" sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.shr_cptl')" :inputValue="accountAmountOfCapital">
          </form-read-group-label-input>
        </b-col>
        <b-col v-if="accountType === '1'" sm="6" class="form-group">
          <form-read-group-label-input
            :idLabel="$t('common.tva_nbr')" :inputValue="accountIdentifierTVA">
          </form-read-group-label-input>
        </b-col>
      </b-row>
    </template>

    <template slot="footerButtons">
      <b-row class="form-group justify-content-center">
        <b-col md="5" xl="3" offset-xl="4">
          <f7-button
            class="button-action milkyBlockBlack"
            @click="editProfile">
            <f7-icon fa="edit"></f7-icon>
            <span>{{ $t('profilesPage.edit_prfl') }}</span>
          </f7-button>
        </b-col>
        <b-col md="5" xl="3">
          <f7-button
            class="button-action milkyBlockBlack"
            @click="changePassword">
            <f7-icon fa="gear"></f7-icon>
            <span v-if="displayChangerPassword">{{ $t('common.chg_pwd') }}</span>
            <span v-else>{{ $t('common.def_pwd') }}</span>
          </f7-button>
        </b-col>
      </b-row>
      <div class="toolbarPageBottomBlank"></div>
    </template>
  </page-outline>
</template>

<script>
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
// import {errorMessageAlert} from '@/helpers/alert'
// import qrcode from 'qrcode'

import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      accountType: '',
      accountName: '',
      accountLogin: '',
      accountAddress: '',
      accountCity: '',
      accountZipCode: '',
      accountCountry: '',
      accountEmailReference: '',
      accountLegalForm: '',
      accountAmountOfCapital: '',
      accountIdentifierTVA: '',
      displayChangerPassword: true
    }
  },
  created () {
    this.profilesPage_ProfileInformation = this.$i18n.t('leftPanelTitle.prof_info')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.accountType = this.$engine.user.get().type
    this.accountName = this.$engine.user.get().name
    this.accountLogin = this.$engine.user.get().identifier
    this.accountAddress = this.$engine.user.get().address
    this.accountCity = this.$engine.user.get().city
    this.accountZipCode = this.$engine.user.get().zip_code
    this.accountCountry = this.$engine.user.get().country
    this.accountEmailReference = this.$engine.user.get().email_reference
    this.accountLegalForm = this.$engine.user.get().legalForm
    this.accountAmountOfCapital = this.$engine.user.get().amountOfCapital
    this.accountIdentifierTVA = this.$engine.user.get().identifierTVA
  },
  mounted () {
    // var canvas = document.getElementById('qrcodeCanvas')
    //
    // let parameters = {
    //   idAccount: 92
    // }
    // console.log(JSON.stringify(parameters))
    // qrcode.toCanvas(canvas, JSON.stringify(parameters), function (error) {
    //   if (error) console.error(error)
    //   console.log('success!')
    // })
    if (this.$engine.user.connectBy === 'vue-google-oauth2') {
      this.displayChangerPassword = false
    } else {
      this.displayChangerPassword = true
    }
  },
  methods: {
    changePassword () {
      loadPage(this, {
        url: '/profile/changePassword/'
      })
    },
    editProfile () {
      loadPage(this, {
        url: '/profile/edit/'
      })
    }
  }
}
</script>

<style scoped>
.orangeConfirmationButton {
  margin-top: 5%;
}
@media (max-width:  768px) {
  .col-md-3 {
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// CMProfile.vue?03f6fd40